import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const EXSEP_ENDPOINTS = {
  V1: createEndpoints('v1', {
    EXSEP_PROFILE_REQUEST: '/admin/exsep-profile-request/',
    SOPRA_EXPERT: (id: number) => `/admin/sopra-experts/${id}/`,
    AYEN_EXPERT: (id: number) => `/admin/ayen-experts/${id}/`,
    EXSEP_PACKAGE_COSTS: '/admin/exsep-package-costs/',
    INSPECTOR_SHARE_TYPES: '/inspector-share-types/',
    SOPRA_EXPERTS: '/admin/sopra-experts/',
    AYEN_EXPERTS: '/admin/ayen-experts/',
  }),
} as const;
